/**
 * Variant size of a block determines which Secondary and Tertiary blocks, can "fit" within a Primary block
 * with a defined block variant size.
 *
 */
export enum SecondaryBlockSize {
  ExtraSmall = "ExtraSmall",
  Small = "Small",
  Medium = "Medium",
  Large = "Large",
  None = "None",
}

export enum TertiaryBlockSize {
  Default = "Default",
  None = "None",
}
